<template>
    <Popover v-slot="{ open }" class="relative">
        <PopoverButton
            :class="open ? '' : 'text-opacity-90'"
            class="h-input inline-flex items-center px-3 py-2 text-base font-medium text-white border-cyan-600 bg-cyan-600 rounded-tl-md hover:bg-cyan-700 rounded-bl-md group hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
        >
            <FunnelIcon
                :class="open ? '' : 'text-opacity-70'"
                class="w-5 h-5 ml-2 text-white transition duration-150 ease-in-out group-hover:text-opacity-80"
                aria-hidden="true"></FunnelIcon>
            <ChevronDownIcon
                :class="open ? '' : 'text-opacity-70'"
                class="w-5 h-5 ml-2 text-white transition duration-150 ease-in-out group-hover:text-opacity-80"
                aria-hidden="true"
            />
        </PopoverButton>

        <transition
            enter-active-class="transition duration-200 ease-out"
            enter-from-class="translate-y-1 opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="translate-y-0 opacity-100"
            leave-to-class="translate-y-1 opacity-0"
        >
            <PopoverPanel
                class="absolute w-screen max-w-sm z-10 px-4 mt-3 transform -translate-x-14 sm:-translate-x-10 left-1/2 sm:px-0">
                <div class="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                    <div class="p-4 bg-gray-50 flex flex-col space-y-4">
                        <slot></slot>
                    </div>
                </div>
            </PopoverPanel>
        </transition>
    </Popover>
</template>

<script>
import {Popover, PopoverButton, PopoverPanel} from '@headlessui/vue'
import {ChevronDownIcon} from '@heroicons/vue/20/solid'
import {FunnelIcon} from "@heroicons/vue/24/outline";

export default {
    components: {Popover, PopoverButton, PopoverPanel, ChevronDownIcon, FunnelIcon},

    setup() {
        return {}
    },
}
</script>
